import {StyleSheet} from 'react-native';

export const styles = StyleSheet.create({
  ListContainer: {
    backgroundColor: '#fff',
    flex: 1,
  },
  ListLibelle : {
    fontSize: 18,
    color: '#0F579E',
    fontWeight: '700',
    textTransform: 'uppercase',
    marginTop: 24,
    marginBottom: 16,
    marginLeft: 16,
    marginRight: 16,
  },
  ListItemInRow: {
    flexDirection: 'row',
    marginVertical:8,
    marginHorizontal:4,
    backgroundColor: 'white',
    borderRadius: 16,
    borderColor: '#f2f5f6',
    flex: 1,
    alignItems: 'center',
    justifyContent: 'flex-end',
    paddingBottom:8,
    shadowOffset:{  width: 6,  height: 12,  },
    shadowColor: 'black',
    shadowOpacity: 0.06,
    shadowRadius: 16,
    elevation: 5,
  },

  titleBlue: {
    fontSize: 16,
    fontWeight: '700',
    color: '#0F579E',
    marginHorizontal: 24,
    marginVertical:16
  },
  ListItemFontStateTrue: {
    marginVertical: 16,
    marginHorizontal: 24,
    fontSize: 10,
    fontWeight:'700',
    color:'#27AE60'
  },
  ListItemFontStateFalse: {
    marginVertical: 16,
    marginHorizontal: 24,
    fontSize: 10,
    fontWeight:'700',
    color:'#F2994A'
  },
  ListItemFontDate: {
    marginVertical: 16,
    marginHorizontal: 24,
    fontSize: 10,
    fontWeight:'700',
    color:'#1D5C42'
  },
  ListItemFont: {
    marginVertical: 16,
    marginHorizontal: 24,
    fontSize: 14,
    color:'#000'
  },
  ListItemLogo: {
    width: 24,
    height: 24,
    margin: 8,
    resizeMode:'contain'
  },
});
